// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"6edeb081","381":"853c0dea","494":"17c8f84c","722":"68a384e9","817":"67bb39ae","820":"d92b0295"}[chunkId] + ".chunk.css";
};